import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './hooks';
export function RequireAuth({ children }) {
    const { session, loading } = useSession();
    const loc = useLocation();
    if (loading)
        return _jsx("div", { className: "p-8 text-slate-500", children: "Loading\u2026" });
    if (!session)
        return _jsx(Navigate, { to: `/login?next=${encodeURIComponent(loc.pathname)}`, replace: true });
    return _jsx(_Fragment, { children: children });
}
